// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xu-1";
export var printerIcon = "_xu-0";